import React, { useCallback } from 'react';

import Table from '../shared/table/TableRemote';

const ConnectedCasesTable = (props) => {
  const {
    onSelectCase,
    cases,
    selectedCaseId,
    handleCheck,
    checkedCases,
    handleCheckAll,
    withoutCheck,
    rowColor,
    rowBorderColor,
    pagination,
    // checkboxes,
    filter,
    filterOptions,
    onFilterChange,
    tenants = [],
    order,
    setOrder,
    orderBy,
    setOrderBy,
    page,
    setPage,
    rowsPerPage,
    setRowsPerPage,
    loading,
    totalRows,
  } = props;

  const columns = [
    { title: '', field: 'caseStatus', type: 'caseStatus', sort: false },
    // { title: 'case id', field: 'formattedId', type: 'default' },
    // { title: 'created at', field: 'createdAt', type: 'date', sort: true },
    { title: 'case date', field: 'date', type: 'date', sort: true },
    { title: 'surgeon', field: 'surgeonName', type: 'default', sort: true },
    { title: 'hospital', field: 'hospitalName', type: 'default', sort: true },
    { title: 'state', field: 'hospitalState', type: 'default', sort: true },
    { title: 'patient ref', field: 'patientReference', type: 'default', sort: true },
    { title: 'procedure', field: 'procedureName', type: 'default', sort: true },
    {
      title: 'company',
      field: 'tenantId',
      type: 'custom',
      formatter: (value) => {
        const tenant = tenants?.find((t) => t.id === value);
        return (
          <div className='d-flex flex-center'>
            {tenant?.icon?.downloadUrl && (
              <img src={tenant?.icon?.downloadUrl} alt='company-icon' style={{ width: 'auto', height: 30, marginRight: 8 }} />
            )}
            {/*<span className='font-bold'>{tenant?.businessName}</span>*/}
          </div>
        );
      }
    }
  ];

  const getFormattedId = useCallback((caseId) => {
    if (!caseId) {
      return ''
    }
    const arr = caseId?.split('-');
    return arr?.length > 1 ? `${arr[0]}-${arr[1]}` : caseId;
  }, []);

  return (
    <div style={{ width: '100%' }}>
      <Table
        className='cases-table'
        rows={cases.map((item) => ({
          ...item,
          formattedId: getFormattedId(item.caseId),
          caseStatus: { status: item.status, canceled: !item.active, kitVariant: item.kitVariant }
        }))}
        columns={columns}
        onRowClick={onSelectCase}
        selected={selectedCaseId}
        handleCheck={handleCheck}
        checkedRows={checkedCases}
        handleCheckAll={handleCheckAll}
        withoutCheck={withoutCheck}
        rowColor={rowColor}
        rowBorderColor={rowBorderColor}
        pagination={pagination}
        checkboxes={false}
        currentFilter={filter}
        filterOptions={filterOptions}
        onFilterChange={onFilterChange}
        noCheckAll
        order={order}
        setOrder={setOrder}
        orderBy={orderBy}
        setOrderBy={setOrderBy}
        page={page}
        setPage={setPage}
        rowsPerPage={rowsPerPage}
        setRowsPerPage={setRowsPerPage}
        totalRows={totalRows || cases?.length}
        loading={loading}
      />
    </div>
  );
};

export default ConnectedCasesTable;
